import React from 'react';

class Hero extends React.Component {
    render() {

        return (
            <div>
                {/* Hero Section */}
                <div id="hero-area" className="hero-area-bg">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 col-sm-12">
                                <div className="contents text-center">
                                    <h2 className="head-title wow fadeInUp">We Design, Develop Customisable <br /> Business Solutions</h2>
                                    <div className="header-button wow fadeInUp" data-wow-delay="0.3s">
                                        <a href="#services" className="btn btn-common">Explore</a>
                                    </div>
                                </div>
                                <div className="img-thumb text-center wow fadeInUp" data-wow-delay="0.6s">
                                    <img className="img-fluid" src="assets/img/hero-1.png" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Hero;


// WEBPACK FOOTER //
// ./src/sections/Hero.js